import { Outlet, Navigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import { useAuth } from "./AuthContext";

function PrivateRoute({ permissions = [] }) {
  const { user, loading } = useAuth(); // Use `loading` and `user` from AuthContext

  // Show a loading spinner while the user data is being fetched
  if (loading) {
    return (
      <MDBox display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress color="inherit" />
      </MDBox>
    );
  }

  // Check if the user exists and has the required permissions
  const hasPermission = user && permissions.includes(user.permissions);

  // Redirect logic
  if (!user) {
    return <Navigate to="/authentication/sign-in" replace />; // Redirect to sign-in if no user
  }

  if (!hasPermission) {
    return <Navigate to="/sprays" replace />; // Redirect to /sprays if user lacks permissions
  }

  // Render the protected route if the user has the required permissions
  return <Outlet />;
}

export default PrivateRoute;
